import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensFillableFormResponse, CitizensFillableFormResponseInput} from './citizens-fillable-form-response.model';

export const loadCitizensFillableFormResponses = createAction(
  '[CitizensFillableFormResponse/API] Load CitizensFillableFormResponses',
  props<{ citizensFillableFormResponses: CitizensFillableFormResponse[] }>()
);

export const addCitizensFillableFormResponse = createAction(
  '[CitizensFillableFormResponse/API] Add CitizensFillableFormResponse',
  props<{ citizensFillableFormResponse: CitizensFillableFormResponse }>()
);

export const upsertCitizensFillableFormResponse = createAction(
  '[CitizensFillableFormResponse/API] Upsert CitizensFillableFormResponse',
  props<{ citizensFillableFormResponse: CitizensFillableFormResponse }>()
);

export const addCitizensFillableFormResponses = createAction(
  '[CitizensFillableFormResponse/API] Add CitizensFillableFormResponses',
  props<{ citizensFillableFormResponses: CitizensFillableFormResponse[] }>()
);

export const upsertCitizensFillableFormResponses = createAction(
  '[CitizensFillableFormResponse/API] Upsert CitizensFillableFormResponses',
  props<{ citizensFillableFormResponses: CitizensFillableFormResponse[] }>()
);

export const updateCitizensFillableFormResponse = createAction(
  '[CitizensFillableFormResponse/API] Update CitizensFillableFormResponse',
  props<{ citizensFillableFormResponse: Update<CitizensFillableFormResponse> }>()
);

export const updateCitizensFillableFormResponses = createAction(
  '[CitizensFillableFormResponse/API] Update CitizensFillableFormResponses',
  props<{ citizensFillableFormResponses: Update<CitizensFillableFormResponse>[] }>()
);

export const deleteCitizensFillableFormResponse = createAction(
  '[CitizensFillableFormResponse/API] Delete CitizensFillableFormResponse',
  props<{ id: string }>()
);

export const deleteCitizensFillableFormResponses = createAction(
  '[CitizensFillableFormResponse/API] Delete CitizensFillableFormResponses',
  props<{ ids: string[] }>()
);

export const clearCitizensFillableFormResponses = createAction(
  '[CitizensFillableFormResponse/API] Clear CitizensFillableFormResponses'
);

// CUSTOM
export const createCitizensFillableFormResponses = createAction(
  '[CitizensFillableFormResponse/API] Create CitizensFillableFormResponses',
  props<{ input: CitizensFillableFormResponseInput }>()
);
